<template>
  <div>
    <ul class="nav nav-tabs" role="tablist" :id="'nav-tabs-' + id">
      <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" :href="'#graph-' + id" :id="'tab-graph-' + id">Graph</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" :href="'#table-' + id" :id="'tab-table-' + id">Table</a>
      </li>
    </ul>
    <div class="tab-content" :id="'tab-content-' + id">
      <div class="tab-pane fade show active" role="tabpanel" :id="'graph-' + id">
        <div class="chart-container" :id="'chart-container-' + id">
          <canvas ref="canvas"></canvas>
        </div>
      </div>
      <div class="tab-pane fade" role="tabpanel" :id="'table-' + id">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th></th>
              <th v-for="header in tableHeaders" :key="header.label">{{ header.label }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in tableRows" :key="row.label">
              <td>{{ row.label }}</td>
              <td v-for="(value,index) in row.data" :key="index">{{ value }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, LineElement, LinearScale, CategoryScale, PointElement, BarController, LineController } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, BarElement, LineElement, LinearScale, CategoryScale, PointElement, BarController, LineController);

export default {
  name: 'MixedChart',
  
  props: {
    chartData: {
      type: Object,
      required: true
    },
    chartOptions: {
      type: Object,
      required: true
    }
  },

  created() {
    
  },

  data() {
    return {
      id: Math.random().toString(36).substring(2,15),
    }
  },

  computed: {
    tableRows() {
      return this.chartData.datasets.map(dataset => {
        return {
          label: dataset.label,
          data: dataset.data.length < 12 ? [...dataset.data, ...Array(12 - dataset.data.length).fill('')] : dataset.data
        }
      })
    },
    tableHeaders() {
      return this.chartData.labels.map(label => {
        return {
          label: label
        }
      })
    }
  },

  mounted() {
    this.renderChart();
  },

  watch: {
    chartData: {
      handler() {
        this.$data._chart.destroy();
        this.renderChart();
      },
      deep: true
    },
    chartOptions: {
      handler() {
        this.$data._chart.destroy();
        this.renderChart();
      },
      deep: true
    }
  },

  methods: {
    renderChart() {
      if (this.chartData && this.chartData.labels && this.chartData.labels.length > 0) {
        this.$nextTick(() => {
          // Create mixed chart with both bar and line datasets
          const ctx = this.$refs.canvas.getContext('2d');
          
          // Destroy existing chart if it exists
          if (this.$data._chart) {
            this.$data._chart.destroy();
          }

          // Process datasets to separate bar and line types
          const barDatasets = this.chartData.datasets.filter(dataset => dataset.type === 'bar' || !dataset.type);
          const lineDatasets = this.chartData.datasets.filter(dataset => dataset.type === 'line');

          // Create the mixed chart using line as base type with mixed datasets
          this.$data._chart = new ChartJS(ctx, {
            type: 'line', // Use line as base type for mixed charts
            data: {
              labels: this.chartData.labels,
              datasets: [
                ...barDatasets.map(dataset => ({
                  ...dataset,
                  type: 'bar'
                })),
                ...lineDatasets.map(dataset => ({
                  ...dataset,
                  type: 'line',
                }))
              ]
            },
            options: {
              ...this.chartOptions,
              scales: {
                ...this.chartOptions.scales,
                y: {
                  type: 'linear',
                  display: true,
                  position: 'left',
                  ...this.chartOptions.scales?.y
                },
              }
            }
          });
        });
      }
    }
  }
}
</script>

<style scoped>
.chart-container {
  position: relative;
  height: 400px;
  width: 100%;
}
</style>
